export default "__VITE_ASSET__DXxuo3tI__"